import { Component, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: "snackbar-info",
  templateUrl: "snackbar-info.template.html",
  styleUrls: ["snackbar-info.style.scss"]
})
export class SnackBarInfoComponent {
  titulo: string;
  mensaje: string;
  textoBoton: string;
  funcion: any;

  snackBarRef: MatSnackBarRef<SnackBarInfoComponent>;

  ejecutar(): void {
    if (!this.funcion) this.snackBarRef.dismiss();
    else {
      this.funcion();
      this.snackBarRef.dismiss();
    }
  }
}
